import { useUserContext, UserProvider } from './userSlice';

export { UserProvider };
export default useUserContext;
